export const commonCardStyles = () => {
  return {
    borderRadius: 'var(--border-radius-md)',
    border: 'var(--border-neutral-normal)',
    backgroundColor: 'var(--theme-color-surface-d0)'
  }
}
